import {
    type FC
} from "react";
import type IPaginationItemProps from "./type";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    usePaginationContext
} from "../../context";
import {
    formatNumber
} from "../../../../helpers/locale/format";
import PaginationControl from "../control";

const PaginationItem: FC<IPaginationItemProps> = ({
    customTheme: customThemeProp,
    isDisabled: isDisabledProp,
    isCurrent: isCurrentProp,
    href: hrefProp,
    onPress,
    style,
    page
}) => {
    const context = usePaginationContext();

    const {
        activeLocale,
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const label = formatNumber({
        locale: activeLocale,
        value: page
    });

    const handlePress = () => {
        if(onPress) {
            onPress();

            return;
        }

        context.onPageChange(page);
    };

    return <PaginationControl
        customTheme={customThemeProp ?? context.customTheme}
        isCurrent={isCurrentProp ?? context.page === page}
        isDisabled={isDisabledProp ?? context.isDisabled}
        href={hrefProp ?? context.hrefExtractor?.(page)}
        aria-label={localize("pagination-page", [
            label
        ])}
        onPress={handlePress}
        size={context.size}
        style={style}
        title={label}
        kind="page"
    />;
};
export default PaginationItem;
